import { VendorConstant } from "./vendorConstant";

const VendorActions = {};

VendorActions.getVendorCity = () => ({
  type: VendorConstant.VENDOR_CITY_SAGA,
});

VendorActions.getVendorSeeAllRequest = () => ({
  type: VendorConstant.VENDOR_SEEALLRES_SAGA,
});

VendorActions.getVendorCount = () => ({
  type: VendorConstant.VENDOR_COUNT_SAGA,
});

//approve enable disable
VendorActions.postApproveRequest = (pay) => {
 
  return {
    type: VendorConstant.APPROVE_ENABLE_DISABLE_SAGA,
    payload: pay,
  };
};

//Reject Request
VendorActions.postRejectRequest = (pay) => {
  
  return {
    type: VendorConstant.REJECT_ENABLE_DISABLE_SAGA,
    payload: pay,
  };
};

//vendor enable disable
VendorActions.postVendorRequest = ({ pay }) => {
  return {
    type: VendorConstant.APPROVE_ENABLE_DISABLE_SAGA,
    payload: pay,
  };
};

export { VendorActions };
